const ColorsReducer = {
    
}

export default ColorsReducer